import React from 'react'
import type { LotteryRound } from '../../services/lotteryService'
import LotteryResultSectionHeader from './LotteryResultSectionHeader'

type Props = {
  sectionTitle: string
  rounds: LotteryRound[]
  onRoundClick?: (round: LotteryRound) => void
}

/** แปลง roundNumber เช่น LYK-20260204-023 → "23" (ตัด leading zero), รายชั่วโมง→1-24, ราย15นาที→ใช้เลขท้าย */
function getYeekeeRoundDisplay(roundNumber: string): string {
  if (!roundNumber?.trim()) return '-'
  const parts = roundNumber.split('-')
  const last = parts[parts.length - 1]
  if (!last) return roundNumber
  const num = parseInt(last, 10)
  return isNaN(num) ? last : String(num)
}

/** Section: จับยี่กี - รอบที่ X, เวลา, 3ตัวบน, 2ตัวล่าง. Uses bgg-7. ตรงภาพ/HTML */
const LotteryResultSectionYeekee: React.FC<Props> = ({
  rounds,
  onRoundClick,
}) => {
  return (
    <>
      {rounds.map((round) => {
        const yeekee = round.yeekee
        const res = yeekee?.result
        const threeUp = res?.threeDigitTop ?? ''
        const twoDown = res?.twoDigitDown ?? res?.twoDigitTop ?? ''
        const drawTime = new Date(round.betStartTime).toLocaleTimeString('th-TH', {
          timeZone: 'Asia/Bangkok',
          hour: '2-digit',
          minute: '2-digit',
        })
        const drawLabel = `รอบ ${drawTime} น.`
        const isClickable = !!onRoundClick
        return (
          <div key={round._id} className="col-12 col-lg-6 px-1 mb-4">
            <LotteryResultSectionHeader
              title={round.huayName}
              iconUrl={round.huayTypeIcon}
              drawLabel={drawLabel}
            />
            <div
              className="wrap-box p-2 pt-0 bgg-7 bdr-5"
              style={isClickable ? { cursor: 'pointer' } : undefined}
              onClick={() => onRoundClick?.(round)}
              onKeyDown={(e) => e.key === 'Enter' && onRoundClick?.(round)}
              role={isClickable ? 'button' : undefined}
              tabIndex={isClickable ? 0 : undefined}
            >
              <div className="row mx--1">
                <div className="col-12 px--1 mt-2 animateMe" data-animation="fadeInUp">
                  <div className="t-medium c-white text-center">
                    <small>รอบที่ {getYeekeeRoundDisplay(round.roundNumber || '')}</small>
                  </div>
                  <div className="bg-white bdr-5 bx-sd p-1 text-center">
                    <div className="px-1">
                      <h4>เวลา :{drawTime} น.</h4>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6 px--1 mt-1 animateMe" data-animation="fadeInUp">
                  <div className="t-medium c-white text-center">
                    <small>3ตัวบน</small>
                  </div>
                  <div className="bg-white bdr-5 bx-sd p-1 text-center">
                    <div className="px-1">
                      <h5>{threeUp || 'รอผล'}</h5>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6 px--1 mt-1 animateMe" data-animation="fadeInUp">
                  <div className="t-medium c-white text-center">
                    <small>2ตัวล่าง</small>
                  </div>
                  <div className="bg-white bdr-5 bx-sd p-1 text-center">
                    <div className="px-1">
                      <h5>{twoDown || 'รอผล'}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      })}
    </>
  )
}

export default LotteryResultSectionYeekee
